import React from 'react';
import { useTranslation } from 'react-i18next';
import SEO from '../components/SEO';

const AGB = () => {
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language;

  const seoData = {
    title: currentLang === 'ru' ? 'Условия использования - FotografX.de' : 'AGB - Allgemeine Geschäftsbedingungen - FotografX.de',
    description: currentLang === 'ru' ? 'Условия использования услуг фотографии FotografX.de' : 'Allgemeine Geschäftsbedingungen für Fotografie-Dienstleistungen von FotografX.de',
    keywords: currentLang === 'ru' ? 'условия, fotografx, фотография' : 'AGB, Geschäftsbedingungen, FotografX, Fotografie'
  };

  return (
    <div className="bg-black text-white">
      <SEO {...seoData} />
      
      {/* Hero Section */}
      <section className="relative pt-24 pb-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 
            className="text-4xl md:text-5xl font-bold mb-6 text-center"
            style={{ fontFamily: '"Times New Roman", serif' }}
          >
            {currentLang === 'ru' ? 'Условия использования' : 'Allgemeine Geschäftsbedingungen'}
          </h1>
          <p className="text-xl text-gray-300 text-center max-w-2xl mx-auto">
            {currentLang === 'ru' 
              ? 'Условия предоставления фотографических услуг'
              : 'Bedingungen für die Erbringung von Fotografie-Dienstleistungen'
            }
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="py-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose prose-invert prose-lg max-w-none">
            {currentLang === 'ru' ? (
              // Russian Content
              <div className="space-y-8">
                <div>
                  <h2 className="text-2xl font-bold mb-4" style={{ fontFamily: '"Times New Roman", serif' }}>
                    1. Область применения
                  </h2>
                  <p className="text-gray-300 leading-relaxed">
                    Настоящие общие условия ведения бизнеса применяются ко всем договорам между FotografX.de 
                    (далее именуемый "Фотограф") и заказчиком (далее именуемый "Клиент") относительно 
                    фотографических услуг. Любые отклоняющиеся условия клиента не признаются, 
                    если только фотограф не согласился с ними в письменной форме.
                  </p>
                </div>

                <div>
                  <h2 className="text-2xl font-bold mb-4" style={{ fontFamily: '"Times New Roman", serif' }}>
                    2. Заключение договора
                  </h2>
                  <p className="text-gray-300 leading-relaxed mb-4">
                    Предложения фотографа не являются обязательными. Договор заключается посредством 
                    письменного подтверждения заказа фотографом или началом выполнения услуг.
                  </p>
                  <p className="text-gray-300 leading-relaxed">
                    Все договоренности, дополнения и изменения договора должны быть оформлены в письменном виде.
                  </p>
                </div>

                <div>
                  <h2 className="text-2xl font-bold mb-4" style={{ fontFamily: '"Times New Roman", serif' }}>
                    3. Цены и условия оплаты
                  </h2>
                  <p className="text-gray-300 leading-relaxed mb-4">
                    Цены указаны в евро и включают установленный законом налог на добавленную стоимость. 
                    Если не согласовано иное, счета подлежат оплате в течение 14 дней с даты выставления счета без скидки.
                  </p>
                  <p className="text-gray-300 leading-relaxed">
                    При мероприятиях продолжительностью более 4 часов взимается предоплата в размере 50% 
                    от общей суммы договора.
                  </p>
                </div>

                <div>
                  <h2 className="text-2xl font-bold mb-4" style={{ fontFamily: '"Times New Roman", serif' }}>
                    4. Выполнение услуг
                  </h2>
                  <p className="text-gray-300 leading-relaxed mb-4">
                    Фотограф выполняет свои услуги профессионально и в соответствии с современными 
                    техническими стандартами. Конкретные пожелания клиента должны быть согласованы заранее.
                  </p>
                  <p className="text-gray-300 leading-relaxed">
                    Готовые фотографии предоставляются клиенту в течение 2-4 недель после мероприятия 
                    в цифровом формате высокого разрешения.
                  </p>
                </div>

                <div>
                  <h2 className="text-2xl font-bold mb-4" style={{ fontFamily: '"Times New Roman", serif' }}>
                    5. Авторские права и права использования
                  </h2>
                  <p className="text-gray-300 leading-relaxed mb-4">
                    Фотограф сохраняет все авторские права на созданные фотографии. Клиент получает 
                    простое право использования для частных целей.
                  </p>
                  <p className="text-gray-300 leading-relaxed">
                    Коммерческое использование фотографий требует отдельного письменного соглашения 
                    и может повлечь за собой дополнительные расходы.
                  </p>
                </div>

                <div>
                  <h2 className="text-2xl font-bold mb-4" style={{ fontFamily: '"Times New Roman", serif' }}>
                    6. Отмена и перенос
                  </h2>
                  <p className="text-gray-300 leading-relaxed mb-4">
                    Отмена клиентом возможна до 14 дней до запланированной даты съемки без дополнительных расходов. 
                    При более поздней отмене взимается 50% от согласованного гонорара.
                  </p>
                  <p className="text-gray-300 leading-relaxed">
                    В случае отмены менее чем за 48 часов до мероприятия взимается полная сумма договора.
                  </p>
                </div>

                <div>
                  <h2 className="text-2xl font-bold mb-4" style={{ fontFamily: '"Times New Roman", serif' }}>
                    7. Ответственность
                  </h2>
                  <p className="text-gray-300 leading-relaxed mb-4">
                    Фотограф несет ответственность только за умышленные действия и грубую неосторожность. 
                    Ответственность за простую неосторожность ограничивается суммой договора.
                  </p>
                  <p className="text-gray-300 leading-relaxed">
                    Фотограф не несет ответственности за потерю данных из-за технических дефектов.
                  </p>
                </div>

                <div>
                  <h2 className="text-2xl font-bold mb-4" style={{ fontFamily: '"Times New Roman", serif' }}>
                    8. Применимое право и место юрисдикции
                  </h2>
                  <p className="text-gray-300 leading-relaxed">
                    К договору применяется право Федеративной Республики Германии. 
                    Местом юрисдикции является город регистрации фотографа.
                  </p>
                </div>

                <div className="border-t border-gray-700 pt-8">
                  <p className="text-gray-400 text-sm">
                    Действует с: Сентябрь 2025<br />
                    FotografX.de<br />
                    Статус: Сентябрь 2025
                  </p>
                </div>
              </div>
            ) : (
              // German Content
              <div className="space-y-8">
                <div>
                  <h2 className="text-2xl font-bold mb-4" style={{ fontFamily: '"Times New Roman", serif' }}>
                    1. Geltungsbereich
                  </h2>
                  <p className="text-gray-300 leading-relaxed">
                    Diese Allgemeinen Geschäftsbedingungen gelten für alle Verträge zwischen FotografX.de 
                    (nachfolgend "Fotograf" genannt) und dem Auftraggeber (nachfolgend "Kunde" genannt) 
                    über fotografische Leistungen. Abweichende Bedingungen des Kunden werden nicht anerkannt, 
                    es sei denn, der Fotograf hat ihnen schriftlich zugestimmt.
                  </p>
                </div>

                <div>
                  <h2 className="text-2xl font-bold mb-4" style={{ fontFamily: '"Times New Roman", serif' }}>
                    2. Vertragsschluss
                  </h2>
                  <p className="text-gray-300 leading-relaxed mb-4">
                    Angebote des Fotografen sind freibleibend. Der Vertrag kommt durch schriftliche 
                    Auftragsbestätigung des Fotografen oder durch Beginn der Leistungserbringung zustande.
                  </p>
                  <p className="text-gray-300 leading-relaxed">
                    Alle Vereinbarungen, Ergänzungen und Änderungen des Vertrages bedürfen der Schriftform.
                  </p>
                </div>

                <div>
                  <h2 className="text-2xl font-bold mb-4" style={{ fontFamily: '"Times New Roman", serif' }}>
                    3. Preise und Zahlungsbedingungen
                  </h2>
                  <p className="text-gray-300 leading-relaxed mb-4">
                    Die Preise verstehen sich in Euro inklusive der gesetzlichen Mehrwertsteuer. 
                    Soweit nicht anders vereinbart, sind Rechnungen innerhalb von 14 Tagen nach 
                    Rechnungsdatum ohne Abzug zu begleichen.
                  </p>
                  <p className="text-gray-300 leading-relaxed">
                    Bei Veranstaltungen über 4 Stunden wird eine Anzahlung in Höhe von 50% der 
                    Gesamtauftragssumme fällig.
                  </p>
                </div>

                <div>
                  <h2 className="text-2xl font-bold mb-4" style={{ fontFamily: '"Times New Roman", serif' }}>
                    4. Leistungserbringung
                  </h2>
                  <p className="text-gray-300 leading-relaxed mb-4">
                    Der Fotograf erbringt seine Leistungen fachgerecht und nach dem aktuellen Stand der Technik. 
                    Besondere Wünsche des Kunden sind im Vorfeld abzustimmen.
                  </p>
                  <p className="text-gray-300 leading-relaxed">
                    Die fertigen Fotografien werden dem Kunden innerhalb von 2-4 Wochen nach der 
                    Veranstaltung in digitaler Form in hoher Auflösung zur Verfügung gestellt.
                  </p>
                </div>

                <div>
                  <h2 className="text-2xl font-bold mb-4" style={{ fontFamily: '"Times New Roman", serif' }}>
                    5. Urheberrecht und Nutzungsrechte
                  </h2>
                  <p className="text-gray-300 leading-relaxed mb-4">
                    Der Fotograf behält alle Urheberrechte an den erstellten Fotografien. 
                    Der Kunde erhält ein einfaches Nutzungsrecht für private Zwecke.
                  </p>
                  <p className="text-gray-300 leading-relaxed">
                    Eine gewerbliche Nutzung der Fotografien bedarf einer gesonderten schriftlichen 
                    Vereinbarung und kann zusätzliche Kosten verursachen.
                  </p>
                </div>

                <div>
                  <h2 className="text-2xl font-bold mb-4" style={{ fontFamily: '"Times New Roman", serif' }}>
                    6. Stornierung und Verschiebung
                  </h2>
                  <p className="text-gray-300 leading-relaxed mb-4">
                    Eine Stornierung durch den Kunden ist bis 14 Tage vor dem geplanten Aufnahmetermin 
                    kostenfrei möglich. Bei späterer Stornierung werden 50% des vereinbarten Honorars fällig.
                  </p>
                  <p className="text-gray-300 leading-relaxed">
                    Bei Stornierung weniger als 48 Stunden vor der Veranstaltung wird die volle 
                    Auftragssumme in Rechnung gestellt.
                  </p>
                </div>

                <div>
                  <h2 className="text-2xl font-bold mb-4" style={{ fontFamily: '"Times New Roman", serif' }}>
                    7. Haftung
                  </h2>
                  <p className="text-gray-300 leading-relaxed mb-4">
                    Der Fotograf haftet nur für Vorsatz und grobe Fahrlässigkeit. Die Haftung für 
                    leichte Fahrlässigkeit ist auf die Auftragssumme begrenzt.
                  </p>
                  <p className="text-gray-300 leading-relaxed">
                    Für Datenverlust durch technische Defekte übernimmt der Fotograf keine Haftung.
                  </p>
                </div>

                <div>
                  <h2 className="text-2xl font-bold mb-4" style={{ fontFamily: '"Times New Roman", serif' }}>
                    8. Anwendbares Recht und Gerichtsstand
                  </h2>
                  <p className="text-gray-300 leading-relaxed">
                    Für den Vertrag gilt das Recht der Bundesrepublik Deutschland. 
                    Gerichtsstand ist der Sitz des Fotografen.
                  </p>
                </div>

                <div className="border-t border-gray-700 pt-8">
                  <p className="text-gray-400 text-sm">
                    Gültig ab: September 2025<br />
                    FotografX.de<br />
                    Stand: September 2025
                  </p>
                </div>
              </div>
            )}
          </div>
        </div>
      </section>
    </div>
  );
};

export default AGB;